<template>
  <div class="basic_style_asset file-asset" :class="{ as_list: renderAsList }">
    <UercRibbon v-if="isUercSurvey" />
    <div class="wrapper no-footer">
      <div class="header">
        <div class="asset-type">
          <i :class="assetIcon" />
          <h6>{{ assetLabel }}</h6>
        </div>
      </div>
      <h2 v-if="fileAsset.title">{{ fileAsset.title }}</h2>
      <div v-if="fileAsset.description" class="description mt-1">{{ fileAsset.description }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import UercRibbon from '@app/graphics/UercRibbon.vue'

export default {
  name: 'FileAsset',
  components: { UercRibbon },
  props: {
    fileAsset: { type: Object, required: true },
    // Toggle to check if the FileAsset should be rendered in a "List" context
    renderAsList: { type: Boolean, required: false, default: false },
  },
  computed: {
    isUercSurvey() {
      return this.fileAsset?.tag_list?.includes('Research')
    },

    assetIcon() {
      const contentType = this.fileAsset?.content_type
      if (contentType === 'image') return 'bi bi-image'
      if (contentType === 'pdf') return 'bi bi-file-richtext-fill'
      return 'bi bi-file-earmark' // fallback for unknown types
    },

    assetLabel() {
      const contentType = this.fileAsset?.content_type
      if (contentType === 'pdf') return 'PDF Asset'
      return 'Media Asset' // fallback for unknown types
    },
  },
}
</script>

<style lang="sass" scoped>
.description
  color: rgba(108, 116, 125, 1)
  font-weight: 400
  font-size: 0.875em

.as_list
  .description
    font-size: 0.8em
</style>
